module.exports = __webpack_public_path__ + "img/itsme2.0461a742.jpg";